import type { TAdminAccount } from 'types'

const ORGANIZATION_LABEL_SEPARATOR = '、'

export function getAccountOrganizationLabel(account: TAdminAccount): string {
  return account.memberships
    .map((membership) => membership.organizationName)
    .join(ORGANIZATION_LABEL_SEPARATOR)
}
